export const techDocType = [
    {value:'1',label:'前端服务器'},
    {value:'2',label:'antd-mobile'},
    {value:'3',label:'团队报账单销售'},
]
